import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/pricing-calculator.tsx");
